import i18n from 'i18next';

function DisclaimerContent() {
    if (i18n.language === "CHT") {
        return (
            <div>
                <p>凱基證券亞洲有限公司、香港聯合交易所有限公司、香港交易所資訊服務有限公司及／或其各別之控股公司、附屬公司、關聯公司、服務供應商及／或其他有關機構竭力確保彼等所提供資料的準確性及可靠性，但均不會對此作出任何擔保，且概不會就因有關資料不準確或遺漏而造成的任何損失或損害負上任何責任(不論是否與侵權行為或合同上或其他方面上的責任有關)。</p>
                <p>上海證券交易所、深圳證券交易所及其各別的子公司盡力保證所提供資訊的準確和可靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或遺漏而導致的任何損失或損害承擔責任。</p>
            </div>
        );
    }
    else if (i18n.language === "CHS") {
        return (
            <div>
                <p>凯基证券亚洲有限公司、香港联合地产有限公司、香港地产资源服务有限公司/其他各别供应公司、附属公司、关联公司、服务商及/或其他相关机构竭力 保证彼等所提供的资料准确及就，但都不会因此而作出任何相关的承诺，且不会因资料不准确或漏泄而造成任何或损害上的任何责任。 侵权行为或合同上或其他方面的责任）。</p>
                <p>上海不能、深圳南方及其各部门全力保证所提供信息的准确性和可靠度，确保其准确准确和可靠，亦不因信息准确或漏漏而导致的 任何损失或损害承担责任。</p>
            </div>
        );
    }
    else if (i18n.language === "EN") {
        return (
            <div>
                <p>KGI Asia Limited, The Stock Exchange of Hong Kong Limited, HKEx Information Services Limited and/or their respective holding companies, subsidiaries, related companies, service providers and/or other relevant parties endeavor to ensure the accuracy and reliability of the information provided but do not guarantee its accuracy or reliability and do not accept any liability (whether in tort or contract or otherwise) for any loss or damage arising from any inaccuracies or omissions.</p>
                <p>Shanghai Stock Exchange, Shenzhen Stock Exchange and their respective subsidiaries endeavour to ensure the accuracy and reliability of the information provided but do not guarantee its accuracy or reliability and accept no liability (whether in tort or contract or otherwise) for any loss or damage arising from any inaccuracies or omissions.</p>
            </div>
        );
    }
}
  
export default DisclaimerContent;
